/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { colors } from "../../constants/colors.js";
/* Components */
import UCButton from "../buttons/index.js";
/* Styles */
import styles from "./styles.js"


const GridSearchNoData = ({icon, title, buttonText, clearSearch, spinner, description}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.container}>
      {icon}
      <h1>{title}</h1>
      {description && <p>{description}</p>}
      <UCButton
        type="default"
        className={classes.clearBtn}
        text={buttonText}
        onClick={() => clearSearch()}
        loadingStateStyling={classes.clearBtnLoadingState}
        spinner={{
          name: spinner,
          size: 20,
          color: colors.darkerGrey
        }}
      />
    </div>
  )
}

export default GridSearchNoData;